import React, { useEffect, useMemo, useState } from 'react';
import { ContainerNeedHelp } from './styled';
import ContainerLoginFlow from '../../Components/ContainerLoginFlow';
import HeaderSection from '../../Components/HeaderSection';
import { ReactComponent as DianaImgNeedHelp } from '../../assets/diana/grupo-direcional/diana-precisa-ajuda.svg';
import { ReactComponent as DianaImgNeedHelpMobile } from '../../assets/diana/grupo-direcional/diana-precisa-ajuda-responsivo.svg';
import { ReactComponent as DianaImgNeedHelpTablet } from '../../assets/diana/grupo-direcional/diana-precisa-ajuda-tablet.svg';
import NameInput from '../../Components/Inputs/NameInput';
import EmailInput from '../../Components/Inputs/EmailInput';
import PhoneInput from '../../Components/Inputs/PhoneInput';
import CpfCnpjInput from '../../Components/CpfCnpj';
import DescriptionInput from '../../Components/DescriptionInput';
import { validarCPFCNPJ, validarTelefone } from '../../Utils/validations';
import { validarEmail } from '../../Utils/validations';
import { ButtonPrimary, Spinner } from '../../Components/StyledComponent';
import { registraAtendimento } from '../../services/meAjuda';
import MessagePopUp from '../../Components/MessagePopup';
import { getPoliticaDePrivacidade } from '../../services/termo';
import PrivacyPolicyCheckbox from '../../Components/PrivacyPolicyCheckbox';
import { useHistory } from 'react-router-dom';
import useWindowDimension from '../../hooks/WindowDimension';
const NeedHelpForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isShowSuccessModal, setIsShowSuccessModal] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [privacyPolicyLink, setPrivacyPolicyLink] = useState('');

  const initialState = {
    Nome: '',
    Email: '',
    Celular: '',
    CpfCnpj: '',
    Descricao: '',
    PrivacyPolicy: false,
  };
  const [userData, setUserData] = useState({ ...initialState });
  const [userDataValidation, setUserDataValidation] = useState({
    ...initialState,
  });

  const theme = { primaryColor: '#1D3054' };
  const history = useHistory();
  const dimensions = useWindowDimension();
  function validateData(key, value) {
    switch (key) {
      case 'Celular':
        return validarTelefone(value);

      case 'Email':
        return validarEmail(value);

      case 'CpfCnpj':
        return validarCPFCNPJ(value);

      case 'PrivacyPolicy':
        return value === 'true';
      default:
        return !!value?.trim();
    }
  }

  function validate(e) {
    const { id, value } = e.target;
    setUserDataValidation({
      ...userDataValidation,
      [id]: validateData(id, value),
    });
  }

  const isAbleToSend = useMemo(() => {
    const values = Object.values(userDataValidation);
    const hasAnyInvalid = values.some((value) => !value);

    return !hasAnyInvalid;
  }, [userDataValidation]);

  async function submitForm() {
    try {
      setIsLoading(true);
      await registraAtendimento({
        Nome: userData.Nome,
        CPFCNPJ: userData.CpfCnpj,
        Email: userData.Email,
        Telefone: userData.Celular,
        Descricao: userData.Descricao,
        PoliticaPrivacidade: userData.PrivacyPolicy,
      });
      setIsShowSuccessModal(true);
    } catch (error) {
      setIsShowErrorModal(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const getPrivacyPolicy = async () => {
      setPrivacyPolicyLink(await getPoliticaDePrivacidade());
    };
    getPrivacyPolicy();
  }, []);

  return (
    <ContainerLoginFlow>
      <ContainerNeedHelp>
        <div className='icons-diana-reponsive'>
          {dimensions.winWidth < 768 && (
            <DianaImgNeedHelpMobile
              style={{ width: '100vw', height: 'auto' }}
            />
          )}

          {dimensions.winWidth < 1000 && dimensions.winWidth >= 768 && (
            <DianaImgNeedHelpTablet
              style={{ width: '100vw', height: 'auto' }}
            />
          )}
        </div>
        <div className='container-infos'>
          <div className='form-need-help'>
            <HeaderSection
              title={'Atendimento ao cliente'}
              subtitle={
                dimensions.winWidth < 1000
                  ? 'Está com alguma dúvida ou problema? Mande sua mensagem.'
                  : ''
              }
              tema={theme}
              notShowButton
              marginBottom={0}
            />
            <NameInput
              value={userData.Nome}
              userData={userData}
              setValue={setUserData}
              validate={validate}
              valid={userDataValidation.Nome}
            />
            <CpfCnpjInput
              value={userData.CpfCnpj}
              userData={userData}
              setValue={setUserData}
              validate={validate}
              valid={userDataValidation.CpfCnpj}
            />
            <EmailInput
              value={userData.Email}
              userData={userData}
              setValue={setUserData}
              validate={validate}
              valid={userDataValidation.Email}
            />
            <PhoneInput
              value={userData.Celular}
              userData={userData}
              setValue={setUserData}
              validate={validate}
              valid={userDataValidation.Celular}
              placeholder={'Digite um celular válido'}
            />

            <DescriptionInput
              value={userData.Descricao}
              userData={userData}
              setValue={setUserData}
              validate={validate}
              valid={userDataValidation.Descricao}
            />

            <PrivacyPolicyCheckbox
              checked={userData.PrivacyPolicy}
              validate={validate}
              userData={userData}
              setValue={setUserData}
              text={
                <>
                  Confirmo que li e concordo com os termos da{' '}
                  <a href={privacyPolicyLink} target='_blank' rel='noreferrer'>
                    Politica de Privacidade
                  </a>
                </>
              }
            />
            <div className='container-buttons-need-help'>
              <ButtonPrimary
                tema={theme}
                disabled={isLoading || !isAbleToSend}
                fullWidth
                onClick={submitForm}
              >
                {isLoading ? (
                  <>
                    ENVIANDO <Spinner />
                  </>
                ) : (
                  'ENVIAR'
                )}
              </ButtonPrimary>

              <ButtonPrimary
                tema={theme}
                disabled={isLoading}
                fullWidth
                light
                onClick={history.goBack}
              >
                Voltar
              </ButtonPrimary>
            </div>
          </div>

          {dimensions.winWidth > 1000 && (
            <DianaImgNeedHelp className='diana-need-help-desktop' />
          )}
        </div>
      </ContainerNeedHelp>

      {isShowSuccessModal && (
        <MessagePopUp
          theme={theme}
          title={'Contato feito com sucesso!'}
          message={
            <>
              <span>Agradecemos seu contato,</span>
              <br />
              <b>{userData.Email}</b>
              <br />
              <br />

              <span>
                Nossa equipe responderá o seu chamado no email indicado,
                certifique-se de verificar sua caixa de spam antes de abrir um
                novo atendimento.{' '}
              </span>

              <br />
              <br />

              <span>Por favor, entre em contato sempre que precisar.</span>
            </>
          }
        >
          <ButtonPrimary fullWidth tema={theme} onClick={history.goBack}>
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
      {isShowErrorModal && (
        <MessagePopUp
          theme={theme}
          title={'Ocorreu um erro!'}
          isError
          message={
            <>
              Por favor tente novamente mais tarde!
              <br />
              Ou entre em contato conosco através do WhatsApp (31) 4002-2600.
            </>
          }
        >
          <ButtonPrimary
            fullWidth
            tema={theme}
            onClick={() => setIsShowErrorModal(false)}
          >
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </ContainerLoginFlow>
  );
};

export default NeedHelpForm;
